/* eslint-disable no-unused-vars */
export enum PageEnum {
  // basic login path
  BASE_LOGIN = "/login",
  // basic home path
  BASE_HOME = "/article/index",
  // error page path
  ERROR_PAGE = "/exception",
  // error log page path
  ERROR_LOG_PAGE = "/error-log/list",
}
